import { Box, CardActions, Grid } from "@mui/material";
import { ReactComponent as DiscriptionIcon } from "assets/icons/CatalogueCard/discription_icon.svg";
import { ReactComponent as ViewIcon } from "assets/icons/CatalogueCard/eye.svg";
import { ReactComponent as LinkIcon } from "assets/icons/CatalogueCard/link.svg";
import { ReactComponent as RingIcon } from "assets/icons/CatalogueCard/ring.svg";
import { ReactComponent as UserIcon } from "assets/icons/CatalogueCard/user.svg";
import { ReactComponent as DateIcon } from "assets/icons/date.svg";
import Button from "components/ui/Button";
import Card from "components/ui/Card";
import { usePermissions } from "context/PermissionsContext";
import React, { useMemo, useState } from "react";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { getIcon } from "utils/iconsConfig";
import profileImage from "../../../assets/img/profile.png";
import "../../../components/ui/setcard.css";
import "../components/catalogCardNew.css";

import { ReactComponent as MyBinnysLogo } from "assets/catalogSetting/myBinnysLogo.svg";
import StreamingIcon from "assets/icons/StreamingIcon/StreamingIcon";
import { ImageComp } from "components/ui";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import Tooltip from "components/ui/Tooltip";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import { useLocation, useNavigate } from "react-router-dom";

const CatalogueCardNew = ({ data, handleButtonClick, infoClick }) => {
  let navigate = useNavigate();

  let location = useLocation();
  let preState = location.state;
  const { iconsData, id, isArchive, modifiedBy, number, numberOfStyles, owner, profile, subname, designsImgs, newowner, createdDateTime } = data;

  const [modalOpen, setModalOpen] = useState();

  const { archiveCatalog, setArchiveCatalog, setIsLiveStreaming } = useGlobalContext();

  const iconMap = {
    designCount: RingIcon,
    linkCount: LinkIcon,
    viewCount: ViewIcon,
  };

  const isArchiveCatalog = preState && preState?.archiveCatalog ? preState?.archiveCatalog : false;

  const isUnArchivePage = preState?.name?.includes("Archives") && preState?.name?.includes("Catalog");

  const permission = usePermissions();
  // const setArchiveAccess = hasAccessPage(findSpecificPage("Sets", permission), "arch
  const setArchiveAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Set Access"), "archive");
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "v
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;
  const hasViewLinkAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access Management"), "link_management");
  const hasViewMyBinnysAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access Management"), "my_binny's_management");
  const hasUserViewAccess = hasViewLinkAccess ||  hasViewMyBinnysAccess
  
  const permissions = usePermissions();

  const hasViewStreamingAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Live Streaming"), "view");

  const { search } = React.useContext(SortContext);

  //Function start

  const handleCardClick = (isArchive) => {
    if (isArchiveCatalog) return;

    let state;
    if (isArchive) {
      let existingName = [location?.state?.name[0], location?.state?.name[1]];

      state = {
        ...preState,
        name: [...existingName, `${data.number} (${data.subname})`],
        // isLiveStreamActive:data?.isLiveStreamActive,
      };

      navigate(`/Setting/archives/Catalog/${data.id}`, { state });
    } else {
      let numb = typeof data.numberOfStyles === "number" && data.numberOfStyles < 10 ? `0${data.numberOfStyles}` : `${data.numberOfStyles}`;

      let catalogNumberAndCount = encodeURIComponent(`${number} (${subname}) - ${numb}`);
      if (location?.state?.newName === "Create Order") {
        state = { ...location?.state, name: [`${number} (${subname})`] };
      } else {
        state = {
          view: false,
          name: [`${number} (${subname})`],
          catalogSearch: search !== "" ? search : "",
          // isLiveStreamActive: data?.isLiveStreaming || false,
        };

        setIsLiveStreaming(data?.isLiveStreaming || false);
        sessionStorage.setItem("catalogData", JSON.stringify(data));
      }

      sessionStorage.setItem("catalogListScrollRestoreY", String(window.scrollY));
      navigate(`/Catalog/${id}?catalogNumberAndCount=${catalogNumberAndCount}`, { state });
    }
  };

  const handleArchiveClick = (e, id) => {
    e.stopPropagation();
    setModalOpen(true);
  };

  const buttons = [
    {
      btnId: 1,
      title: "Share to",
      view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Share Catalog"), "share_to_my_binny's"),
      // view: hasAccessPage(findSpecificPage("Catalog Setting", permission), "view"),
      // view: true,
    },
    {
      btnId: 2,
      title: "Share Link",
      view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Share Catalog"), "share_via_links"),
      // view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog", permission), "Share Catalog"), "view"),
      // add: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Catalog", permission), "Share Catalog"), "add"),
    },
  ];

  const unArchivesbuttons = [
    {
      btnId: 1,
      title: "Delete",
      style: { color: "#E77B7B !important", fontSize: "18px", border: "1px solid #E77B7B", width: "185px", minWidth: "60px" },
      // view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "archive"),
       view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "archive"),
    },
    {
      btnId: 2,
      title: "Unarchive",
      style: { color: "#50C878 !important", fontSize: "18px", border: "1px solid #50C878", width: "185px", minWidth: "60px" },
      // view: hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Archives"), "edit"),
      view: isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Catalog Access"), "unarchive"),
    },
  ];

  const CatalogArchiveModal = useMemo(
    () => [
      {
        btnName: "Yes,Archive",
        bgColor: "#E77B7B",
        click: () => {
          const catalogData = JSON.parse(sessionStorage.getItem("catalogArchive")) || [];
          setArchiveCatalog([...catalogData, id]);
          const updatedData = [...catalogData, id];
          sessionStorage.setItem("catalogArchive", JSON.stringify(updatedData));
        },
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setModalOpen(false),
      },
    ],
    []
  );

  return (
    <div className="catalog-new-card">
      <Card
        style={{
          padding: "10px",
          borderRadius: "10px",

          minWidth: "420px",
          maxWidth: "420px",

          maxHeight: "257px",
          minHeight: "257px",

          alignItems: "flex-start",
          border: "none",
          gap: "12px",
          flexDirection: "column",
        }}
        onClick={() => handleCardClick(isArchive)}
      >
        <div className="top-side">
          <div className="left-side">
            <div className="content" style={{ width: "100%", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {getIcon("By Catalog")}
                <p className="heading">{data?.subname?.length > 15 ? data?.subname?.slice(0, 15) + "...." : data.subname}</p>
              </div>
              {data?.isLiveStreaming && hasViewStreamingAccess && <StreamingIcon width={"16px"} height={"13px"} style={{ marginRight: "10px" }} color={"white"} />}
            </div>

            <div className="content-new">
              <DiscriptionIcon className="catalogue-card-logo-new" />
              <p className="description-text">{number}</p>
            </div>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {iconsData?.map((entry) => {
                const IconComponent = iconMap[entry.title];

                return (
                  <div className="content-new" key={entry.title}>
                    <IconComponent className="catalogue-card-logo-new" />
                    <Tooltip title={entry.title} marginTop="2px" className="catalogue-card-logo-new">
                      <p className="subdescription-text">{entry.count}</p>
                    </Tooltip>
                  </div>
                );
              })}
            </div>

            <div className="content-new">
              <img src={profile ? profile : profileImage} alt={profileImage} style={{ width: "15px", height: "15px", borderRadius: "40px" }} />
              <p className="description-text">{newowner}</p>
            </div>
            <div className="content-new" onClick={infoClick}>
              <DateIcon className="catalogue-card-logo-new" />
              <p className="description-text">{createdDateTime}</p>
            </div>
          </div>

          <div className="right-side">
            <Grid container spacing={0.5} m={0} p={0}>
              {designsImgs?.map((img, index) => {
                const row = Math.floor(index / 2);
                const col = index % 2;
                const paddingTop = row === 0 ? "0!important" : "inherit";
                const paddingLeft = col === 0 ? "0!important" : "inherit";

                return img?.transformedImageUrl ? (
                  <Grid
                    key={index}
                    item
                    sm={6}
                    lg={6}
                    data-index={index}
                    className="clickable-item"
                    sx={{
                      // width: "92px",
                      // height: "92px",
                      paddingTop,
                      paddingLeft,
                      cursor: "pointer",
                    }}
                  >
                    <div className={`image-div`}>
                      <ImageComp url={img.imageUrl} hasAccessToSeeWatermark={hasAccessToSeeWatermark} />
                      {numberOfStyles - 4 > 0 && index === designsImgs.length - 1 ? <Box className="overlayText">+{numberOfStyles - 4}</Box> : null}
                    </div>
                  </Grid>
                ) : (
                  <Grid
                    key={index}
                    item
                    sm={6}
                    lg={6}
                    sx={{
                      width: "92px",
                      height: "92px",
                      paddingTop,
                      paddingLeft,
                    }}
                  ></Grid>
                );
              })}
            </Grid>
          </div>
        </div>

        {isArchiveCatalog ? (
          <CardActions
            className="button-side"
            sx={{
              padding: "0px",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              disableElevation
              className="card-buttons"
              style={{
                fontFamily: "Poppins",
                width: 400,
                height: 41,
                borderRadius: 5,
                border: "0.5px solid #E77B7B",
                opacity: 1,
                color: "#E77B7B",
              }}
              onClick={(e) => handleArchiveClick(e, data?.id)}
            >
              Archive
            </Button>
          </CardActions>
        ) : isUnArchivePage ? (
          <CardActions className="button-side" sx={{ padding: "0px" }}>
            {unArchivesbuttons
              .filter((btn) => btn.view)
              .map((btn) => (
                <Button
                  sx={{ ...btn.style, "&:hover": { background: "white" } }}
                  key={`btn-${btn.btnId}-${data.id}`}
                  variant="contained"
                  fullWidth
                  disableElevation
                  onClick={(e) => handleButtonClick(data, btn.title, e)}
                >
                  {btn.title}
                </Button>
              ))}
          </CardActions>
        ) : (
          <CardActions
            className="button-side"
            sx={{
              padding: "0px",
              width:
                !hasViewMyBinnysAccess && !hasViewLinkAccess
                  ? "107%"
                  : "100%",
            }}
          >
            {buttons
              // .filter((btn) => btn.view)
              .map((btn) => (
                <Button
                  key={`btn${btn.btnId}`}
                  variant="contained"
                  fullWidth
                  disableElevation
                  className="card-buttons"
                  style={{
                    marginTop: "0px",
                    fontFamily: "poppins",
                    fontWeight: "500",
                    fontSize: "14px",
                    width:
                      btn.title === "Share to"
                        ? hasViewMyBinnysAccess || hasViewLinkAccess
                          ? "263px"
                          : "215px"
                        : "186px",
                    visibility: btn.view ? "visible" : "hidden",
                  }}
                  onClick={(e) => btn.view && handleButtonClick(data, btn.title, e)}
                >
                  {btn.title === "Share to" ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "0.15vw" }}>
                      {btn.title}
                      <div style={{ display: "flex" }}>
                        <MyBinnysLogo width={"1.7vw"} height={"1.25vw"} />
                      </div>
                    </div>
                  ) : (
                    btn.title
                  )}
                </Button>
              ))}

            <div
              onClick={hasViewMyBinnysAccess || hasViewLinkAccess ? (e) => handleButtonClick(data, "users", e) : undefined}
              style={{ visibility: hasUserViewAccess ? "visible" : "hidden" }}
            >
              <UserIcon className="catalogue-card-logo" />
            </div>
          </CardActions>
        )}
      </Card>

      <RemoveModal
        open={modalOpen}
        setOpen={setModalOpen}
        oneLiner={false}
        btnInfo={CatalogArchiveModal}
        heading={
          <pre style={{ fontFamily: "Poppins", margin: 0, fontWeight: "500", fontSize: "18px", lineHeight: "22px" }}>
            Are you sure you want to Archive <span style={{ fontWeight: "600" }}>{data?.number}</span>
            {"\n"}
            Catalog?
          </pre>
        }
      />
    </div>
  );
};

export default CatalogueCardNew;
